import { createValidators } from '../storeValidatorsRules'

const memberValidators = () => createValidators([
    { 'name': 'companyName', 'typeFunction': 'notEmptyString', 'text': 'Company Name' },
    { 'name': 'firstName', 'typeFunction': 'notEmptyString', 'text': 'First Name' },
    { 'name': 'lastName', 'typeFunction': 'notEmptyString', 'text': 'Last Name' },
    //{ 'name': 'siteId', 'typeFunction': 'dropDownValue', 'text': 'Chapter' },
    { 'name': 'email', 'typeFunction': 'email', 'text': 'Email' },
    { 'name': 'phone', 'typeFunction': 'notEmptyString', 'text': 'phone' },
    { 'name': 'phoneValid', 'typeFunction': 'phone', 'text': 'phone', 'field': 'phone' },

    { 'name': 'streetAddress', 'typeFunction': 'notEmptyString', 'text': 'Street Address' },
    { 'name': 'city', 'typeFunction': 'notEmptyString', 'text': 'City' },
    { 'name': 'state', 'typeFunction': 'notEmptyString', 'text': 'State' },
    { 'name': 'zip', 'typeFunction': 'notEmptyString', 'text': 'Zip' },
]);

const adminValidators = () => createValidators([
    { 'name': 'firstName', 'typeFunction': 'notEmptyString', 'text': 'First Name' },
    { 'name': 'lastName', 'typeFunction': 'notEmptyString', 'text': 'Last Name' },
    //{ 'name': 'siteId', 'typeFunction': 'dropDownValue', 'text': 'Chapter' },
    { 'name': 'email', 'typeFunction': 'email', 'text': 'Email' },
    { 'name': 'phone', 'typeFunction': 'notEmptyString', 'text': 'phone' },
    { 'name': 'phoneValid', 'typeFunction': 'phone', 'text': 'phone', 'field': 'phone' },
]);
  
export { memberValidators, adminValidators};



// WEBPACK FOOTER //
// ./src/components/member/memberValidators.jsx